import { render } from "./product-rating.vue?vue&type=template&id=ece8e7e6"
import script from "./product-rating.vue?vue&type=script&lang=js"
export * from "./product-rating.vue?vue&type=script&lang=js"

import "./product-rating.vue?vue&type=style&index=0&id=ece8e7e6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__